module.exports = __webpack_public_path__ + "img/new-step1.236edbd9.jpg";